import {Card, CardContent, CardHeader, CardTitle} from '@common-web/components/ui/card';
import {Button} from '@common-web/components/ui/button';
import {Checkbox} from '@common-web/components/ui/checkbox';
import type {CatalogProduct} from '@client/hooks/useProductSelection';

type AdditionalProductsStepProps = {
  remainingProducts: CatalogProduct[];
  additionalProductIds: string[];
  onToggleAdditionalProduct: (productId: string) => void;
  onSkip: () => void;
  onBack: () => void;
  onContinue: () => void;
};

export function AdditionalProductsStep({
  remainingProducts,
  additionalProductIds,
  onToggleAdditionalProduct,
  onSkip,
  onBack,
  onContinue,
}: AdditionalProductsStepProps) {
  return (
    <>
      <Card className='border-0 shadow-lg bg-white overflow-hidden mb-6'>
        <CardHeader className='bg-gradient-to-r from-gray-50 to-white border-b border-gray-100 px-6 py-4'>
          <CardTitle className='text-lg font-semibold text-brand-navy'>
            Step 3: Additional Products
          </CardTitle>
        </CardHeader>
        <CardContent className='p-6'>
          {remainingProducts.length === 0 ? (
            <p className='text-sm text-gray-400'>
              No additional products available.
            </p>
          ) : (
            <div className='space-y-2'>
              {remainingProducts.map((p: CatalogProduct) => (
                <label
                  key={p.id}
                  className='flex items-center gap-3 p-3 rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors'
                >
                  <Checkbox
                    checked={additionalProductIds.includes(p.id)}
                    onCheckedChange={() => onToggleAdditionalProduct(p.id)}
                  />
                  <div>
                    <p className='text-sm font-medium text-brand-navy'>{p.name}</p>
                    {p.productId && (
                      <p className='text-xs text-gray-500'>{p.productId}</p>
                    )}
                  </div>
                </label>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      <div className='flex items-center justify-between'>
        <Button variant='outline' onClick={onBack}>
          Back
        </Button>
        <div className='flex items-center gap-3'>
          <Button variant='ghost' onClick={onSkip}>
            Skip this step
          </Button>
          <Button onClick={onContinue}>Continue to Review</Button>
        </div>
      </div>
    </>
  );
}
